import { KeyValueModel, ModelBase } from "./ModelBase"

export class YapilyFlowModel extends ModelBase {
    IdContoCorrente: string
    PsuId: string
    PsuCorporateId: string
    PsuIpAddress: string
    Testo: string
    BancaUser: string
    BancaPassword: string
    SelectedMethod?: ScaMethod
    ScaMethods?: Array<ScaMethod>
    ScaCode: string
    ConsentToken: string
    YapilyStatus:string
}

export class ScaMethod {
    id: string
    type: string
    description: string
}

export class YapilyLookupModel extends ModelBase {
    Items: Array<YapilyLookup>
}

export class YapilyLookup extends ModelBase {
    IdIstituto: string
    IdIstitutoBusiness: string
    Abi: string
    Banca: string
    PsuIdMandatory: boolean
    PsuCorporateIdMandatory: boolean
    PsuIpAddressMandatory: boolean
    IsCbi: boolean
    IsEmbeddedFlow: boolean
    HasAccount: boolean
}

export class YapilyConsensiTestoModel extends ModelBase {
    Testo:string
    PsuIdMandatory:boolean
    PsuId:string
    PsuCorporateIdMandatory:boolean
    PsuCorporateId:string
    PsuIpAddressMandatory:boolean
}